import Vue from 'vue'
import Vuex from 'vuex'

import stateNames from "../data/stateNames.js"

const state = {
	currentView: "all",
	locations: null,
	pageTitle: "All Ferrellgas Locations",
	stateNames: stateNames,
};
const getters = {
	currentView: state => state.currentView,
	locations: state => state.locations,
	pageTitle: state => state.pageTitle,
	stateNames: state => state.stateNames,
};
const mutations = {
	setStateValue(state, payloadArray) {
		state[payloadArray[0]] = payloadArray[1];
	}
};
const actions = {
	async getStateData({state, commit}, endpoint) {
		await fetch(endpoint, {
			method: 'GET'
		}).then(response => response.json())
			.then(data => {
				// console.log(data)
				let locationsObj = {};
				data.locationDictionary.forEach(loc => {
					if (!locationsObj[loc.state]) locationsObj[loc.state] = [];
					locationsObj[loc.state].push(loc);
				});
				// sorting occurs below for states by full name, not abbreviated name
				locationsObj = Object.keys(locationsObj).sort((a, b) => {
					if (state.stateNames[a].toLowerCase() < state.stateNames[b].toLowerCase()) return -1;
					else if (state.stateNames[a].toLowerCase() > state.stateNames[b].toLowerCase()) return 1;
					else return 0;
				}).reduce(
					(obj, key) => {
						obj[key] = locationsObj[key];
						return obj;
					}, {}
				);
				// sorting occurs below for locations by city name
				for (const stateObj in locationsObj) {
					locationsObj[stateObj].sort((a, b) => {
						if (a.city.toLowerCase() < b.city.toLowerCase()) return -1;
						else if (a.city.toLowerCase() > b.city.toLowerCase()) return 1;
						else return 0;
					});
				}
				if (!!data.Title) commit('setStateValue', ['pageTitle', data.Title]);
				commit('setStateValue', ['locations', locationsObj]);
			});
	}
}

export default {
	state,
	getters,
	mutations,
	actions
};